class ZipCodeUtils {
  public formatZipCode(zipCode: string | undefined = undefined): string {
    if (zipCode && zipCode.length === 9) {
      return `${zipCode.substr(0, 5)}-${zipCode.substr(5)}`;
    }
    return zipCode || '';
  }
}

const zipCodeUtils = new ZipCodeUtils();

export default zipCodeUtils;
